
import createjs, { Point } from 'createjs-module'

import {FlyerPageDto, FlyerPageSpotDto, FrameIconDataDto, IconStyleDto} from '../../../../dtos'

import { SpotsPersistenceManager } from './persistence/SpotsPersistenceManager'

import { KeyboardManager } from '../../../../com/keyboardManager/KeyboardManager'

import {

    EVENT_TYPE_FLYER_PAGE_CONTROLS_SELECT_ALL_SPOTS,
    EVENT_TYPE_FLYER_PAGE_CONTROLS_UNSELECT_ALL_SPOTS,
    EVENT_TYPE_FLYER_PAGE_CONTROLS_DELETE_SPOTS,
    EVENT_TYPE_FLYER_PAGE_CONTROLS_AUTO_NUMBER,
    EVENT_TYPE_FLYER_PAGE_CONTROLS_RENUMBER_FROM,

    EVENT_TYPE_SPOTS_UNSELECT_ONE_OR_MORE_SPOTS,
    EVENT_TYPE_SPOTS_ALL_SPOTS_SELECTED_WITH_CTRL_A,
    EVENT_TYPE_SPOTS_NO_SPOTS_SELECTED,

    EVENT_DATA_TYPE_SPOT_DRAG_TOP_LEFT,
    EVENT_DATA_TYPE_SPOT_DRAG_TOP_RIGHT,
    EVENT_DATA_TYPE_SPOT_DRAG_BOTTOM_LEFT,
    EVENT_DATA_TYPE_SPOT_DRAG_BOTTOM_RIGHT,
    EVENT_DATA_TYPE_SPOT_PRESS_MOVE,
    EVENT_TYPE_CHANGE_ICON_POSITION,

    dispatchEventType,
    addEventTypeListener,
    addEventDataTypeListener,
    removeEventTypeListener,
    EVENT_TYPE_GET_ALL_SELECTED_SPOTS,
    dispatchEventDataType,
    EVENT_TYPE_FLYER_RIGHT_PANEL_CONTROL_SELECT_NEXT_OR_PREV_FRAME, EVENT_TYPE_FLYER_SAVE_FRAMES_DATA_AND_AUTO_NUMBER
} from '../../../../globals/EventDispatcher'

import {Spot, SpotModelViewDto} from './spot/Spot'

import { CanvasMouseTracker } from '../../../../com/canvas/mouseTracker/CanvasMouseTracker'

import framesGridCreationIcon from '../../../../assets/editors/spots/frames_grid_creation_icon.svg'
import noAccessIcon from '../../../../assets/editors/spots/no_access.svg'
import moveFramesIcon from '../../../../assets/editors/spots/moveFrameIcon.svg'

import { SpotsFunctions } from './SpotsFunctions';
import { SpotsScallingManager } from './scallingManager/SpotsScallingManager'
import { SpotsTranslationManager } from './translationManager/SpotsTranslationManager'
import { StrokedText } from '../../../../com/canvas/strotedText/StrokedText'
import { CustomDataEvent } from '../../../../globals/CustomDataEvent'

export class Spots extends createjs.Container {

    private _isPageContainer: boolean = true;
    private _hitLayer: createjs.Shape | null = null;
    private _pageWidth: number = 0;
    private _pageHeigth: number = 0;
    private _isMouseDown: boolean = false
    private _mouseX0: number = 0
    private _mouseY0: number = 0
    private _currentMouseX: number = 0
    private _currentMouseY: number = 0
    private _lastMouseX: number = 0
    private _lastMouseY: number = 0
    private _isRightCollider: boolean = false;
    private _isBottomCollider: boolean = false;
    private _nextGgridSize: Point | null = null//new Point(3, 3)
    private _innerSpots: Array<Spot> = [];
    private _keyboardManager: KeyboardManager | null = null;
    private _currentSpotsContainer: Spots | null = null
    private _redStokedShape: createjs.Shape | null = null
    private _canvasMouseTracker: CanvasMouseTracker | null = null
    private _isInCtrlClickMode: boolean = false
    private _hitAreaName: string = 'hitAreaContainer'
    public _spotsFunctions: SpotsFunctions | null = null
    private _spotsScallingManager: SpotsScallingManager | null = null;
    private _spotsTranslationManager: SpotsTranslationManager | null = null
    private _isInScallingIndividualSpotsMode: boolean = false
    private _currentEditedSpot: Spot | null = null;
    private _currentSelectedSpotScallerDto: SpotModelViewDto | null = null
    private _currentSelectedSpotsDtos: SpotModelViewDto[] | null = null
    private _hitLayerParent: createjs.Shape | null = null;
    private _originalWidth: number = 0;
    private _originalHeight: number = 0;
    private _isInMoveSpotsMode: boolean = false
    private _translationOffsetX: number = 0
    private _translationOffsetY: number = 0
    public _flyerPageDto: FlyerPageDto | null = null
    private _persistenceManager: SpotsPersistenceManager | null = null
    public _isDisabledZoom: boolean
    public _framesIcons: IconStyleDto | null = null
    private _isInCollisionState: boolean = false

    public setDimensions(camvasWidth: number, camvasHeight: number){
        this._pageWidth = camvasWidth;
        this._pageHeigth = camvasHeight;
        this.enableContainerHitArea(camvasWidth, camvasHeight)
    }

    constructor(isPageContainer: boolean, camvasWidth: number, camvasHeight: number, enableInteractivity: boolean = false, isDisabledZoom: boolean = true, framesIconsData: IconStyleDto | null = null) {

        super()
        this._isDisabledZoom = isDisabledZoom;
        this._isPageContainer = isPageContainer;
        this._framesIcons = framesIconsData;

        this.setDimensions(camvasWidth, camvasHeight)

        this._spotsFunctions = new SpotsFunctions(this);

        //
        if (this._isPageContainer && enableInteractivity) {

            this._persistenceManager = new SpotsPersistenceManager();

            this._spotsScallingManager = new SpotsScallingManager(this);
            this._spotsTranslationManager = new SpotsTranslationManager(this);

            this.addEventListener('added', this.onAddedToStage.bind(this));
            this.addEventListener('removed', this.onRemovedFromStage.bind(this));
            this.addEventListener('pressup', this._spotsScallingManager!.onMainSpotsContainerPressUp.bind(this));

            this.addEventListener('click', this.onMainSpotsContainerClick.bind(this));

            // Keyboard events
            this._keyboardManager = KeyboardManager.getInstance();

            this._keyboardManager.addEventListener(KeyboardManager.CTRL_A, () => {
                this._spotsFunctions!.selectAllPageSpots(true)
                dispatchEventType(EVENT_TYPE_SPOTS_ALL_SPOTS_SELECTED_WITH_CTRL_A);
            })

            this._keyboardManager.addEventListener(KeyboardManager.CTRL_LEFT_MOUSE_CLICK, (event: any) => {
                this._isInCtrlClickMode = true;
            })

            this._keyboardManager.addEventListener(KeyboardManager.DELETE, (event: any) => {
                this._spotsFunctions!.deleteSelectedSpots();
            })
            this._keyboardManager.addEventListener(KeyboardManager.LEFT_ARROW_KEYBOARD_CLICK, (event: any) => {
                this._spotsTranslationManager!.moveSelectedSpots(event);
            })
            this._keyboardManager.addEventListener(KeyboardManager.RIGHT_ARROW_KEYBOARD_CLICK, (event: any) => {
                this._spotsTranslationManager!.moveSelectedSpots(event);
            })
            this._keyboardManager.addEventListener(KeyboardManager.TOP_ARROW_KEYBOARD_CLICK, (event: any) => {
                this._spotsTranslationManager!.moveSelectedSpots(event);
            })
            this._keyboardManager.addEventListener(KeyboardManager.BOTTOM_ARROW_KEYBOARD_CLICK, (event: any) => {
                this._spotsTranslationManager!.moveSelectedSpots(event);
            })

            this._keyboardManager.addEventListener(KeyboardManager.PRESS_UP_ARROWS, (event: any) => {
                this._spotsScallingManager!.onMainSpotsContainerPressUp('');
            })


            // Events
            addEventTypeListener(EVENT_TYPE_FLYER_PAGE_CONTROLS_SELECT_ALL_SPOTS, () => {
                this._spotsFunctions!.selectAllPageSpots(true)
            })

            addEventDataTypeListener(EVENT_TYPE_FLYER_RIGHT_PANEL_CONTROL_SELECT_NEXT_OR_PREV_FRAME, (data: any) => {
                const selectedFrameData = data.data;
                const functions = this._spotsFunctions!;
                functions.selectAllPageSpots(false, true);
                functions.selectFrameUsingFrameDataFromRightPanel(selectedFrameData);
            })

            addEventTypeListener(EVENT_TYPE_FLYER_PAGE_CONTROLS_UNSELECT_ALL_SPOTS, () => {
                this._spotsFunctions!.selectAllPageSpots(false)
            })

            addEventTypeListener(EVENT_TYPE_FLYER_PAGE_CONTROLS_DELETE_SPOTS, () => {
                this._spotsFunctions!.deleteSelectedSpots();
            })

            addEventDataTypeListener(EVENT_TYPE_FLYER_PAGE_CONTROLS_AUTO_NUMBER, (data) => {
                this._spotsFunctions!.reNumberAllSpots(data.data);
            })

            addEventDataTypeListener(EVENT_TYPE_FLYER_SAVE_FRAMES_DATA_AND_AUTO_NUMBER, (data) => {
                const {selectedFrames, newData, isHorizontalOrientationForFrames} = data.data;
                this._spotsFunctions!.reNumberAllSpotsWithDataForSelectedFrames(selectedFrames, newData, isHorizontalOrientationForFrames);
            })

            addEventDataTypeListener(EVENT_TYPE_CHANGE_ICON_POSITION, (data) => {
                const iconDataForUpdate: FrameIconDataDto = {
                    ...data.data
                }
                this._spotsFunctions?.changeIconDataForSelectedFrames(iconDataForUpdate);
            })

            addEventDataTypeListener(EVENT_TYPE_FLYER_PAGE_CONTROLS_RENUMBER_FROM, (data) => {
                this._spotsFunctions!.reNumberFrom(data.data);
            })

            // Spot Events
            addEventDataTypeListener(EVENT_DATA_TYPE_SPOT_DRAG_BOTTOM_RIGHT, (event: CustomDataEvent) => {
                this._spotsScallingManager!.liveDragFromBottomRight(event);
            })

            addEventDataTypeListener(EVENT_DATA_TYPE_SPOT_DRAG_BOTTOM_LEFT, (event: CustomDataEvent) => {
                this._spotsScallingManager!.liveDragFromBottomLeft(event);
            })

            addEventDataTypeListener(EVENT_DATA_TYPE_SPOT_DRAG_TOP_LEFT, (event: CustomDataEvent) => {
                this._spotsScallingManager!.liveDragFromTopLeft(event);
            })

            addEventDataTypeListener(EVENT_DATA_TYPE_SPOT_DRAG_TOP_RIGHT, (event: CustomDataEvent) => {
                this._spotsScallingManager!.liveDragFromTopRight(event);
            })
            if(isDisabledZoom){
                this.addEventListener('pressmove', this._spotsScallingManager!.onMainSpotsContainerPressMove.bind(this))
                addEventDataTypeListener(EVENT_DATA_TYPE_SPOT_PRESS_MOVE, (event: CustomDataEvent) => {
                    this._spotsTranslationManager!.liveMove(event);
                })
            }
        }
    }

    updateSpotsDtos(spotsDtos: FlyerPageSpotDto[]) {
        this.flyerPageDto!.flyerPageSpots = spotsDtos;

        for (let i = 0; i < this._innerSpots.length; i++) {
            const spot = this._innerSpots[i];
            let updatedData = spot.updatedData;
            let positionNo = updatedData.fpsPositionNo

            for (let j = 0; j < spotsDtos.length; j++) {
                const dto = spotsDtos[j];
                if(dto.fpsPositionNo === positionNo){
                    //update spot data
                    spot._data = {
                        ...dto,
                        ...updatedData,
                    }
                    spot.initialData!.fpsRecId = dto.fpsRecId;
                    spot.initialData!.qualificationLevel = dto.qualificationLevel;
                    spot.text = `${dto.fpsPositionNo}`;
                    break;
                }
            }
        }
    }


    enableContainerHitArea(width: number, height: number) {
        this._hitLayerParent = new createjs.Shape(); // Shape is empty
        this._hitLayerParent.name = this._hitAreaName;

        this._hitLayer = new createjs.Shape(new createjs.Graphics().f('red').dr(0, 0, width, height));

        // to have precisse collision detection the minimum alpha is 0.01
        this._hitLayer.alpha = 0.2//0.01;

        // Empty shape has a hitArea, so it is invisible.
        this._hitLayerParent.hitArea = this._hitLayer
        this.addChild(this._hitLayerParent);

        if(!this._isPageContainer) {
            this.addChild(this._hitLayer);
        }

    }

    public updateHitAreaDimensions(width: number, height: number){

        this._originalWidth = width;
        this._originalHeight = height;

        this._hitLayer?.graphics.clear();
        this._hitLayer?.graphics
                       .beginFill('red')
                       .drawRect(0, 0, width, height)
                       .endFill()

        this._hitLayer!.setBounds(0, 0, width, height);
        this._hitLayerParent!.setBounds(0, 0, width, height);

        this.updateStage();
    }

    public backgroundScale(scaleX: number, scaleY: number) {

        this._hitLayer?.graphics.clear();
        this._hitLayer?.graphics
                       .beginFill('red')
                       .drawRect(0, 0, this._originalWidth * scaleX, this._originalHeight * scaleY)
                       .endFill()

        this._hitLayer?.setBounds(0, 0, this._originalWidth * scaleX, this._originalHeight * scaleY)

        this.updateStage();
    }

    public get hitAreaName() {
        return this._hitAreaName
    }

    public dispose() {
        for (let i = 0; i < this.innerSpots.length; i++) {
            const spot = this.innerSpots[i];
            if(spot.parent) {
                spot.parent.removeChild(spot)
            }
            spot.dispose();
        }
        this.innerSpots = [];

        this.removeEventListener('added', this.onAddedToStage);
        this.removeEventListener('removed', this.onRemovedFromStage);

        if(this._spotsScallingManager) {
            this.removeEventListener('pressmove', this._spotsScallingManager!.onMainSpotsContainerPressMove)
        }

        if(this._spotsScallingManager) {
            this.removeEventListener('pressup', this._spotsScallingManager!.onMainSpotsContainerPressUp);
        }

        if(this.onMainSpotsContainerClick) {
            this.removeEventListener('click', this.onMainSpotsContainerClick);
        }

        removeEventTypeListener(EVENT_TYPE_FLYER_PAGE_CONTROLS_SELECT_ALL_SPOTS)
        removeEventTypeListener(EVENT_TYPE_FLYER_RIGHT_PANEL_CONTROL_SELECT_NEXT_OR_PREV_FRAME)
        removeEventTypeListener(EVENT_TYPE_FLYER_PAGE_CONTROLS_UNSELECT_ALL_SPOTS)
        removeEventTypeListener(EVENT_TYPE_FLYER_PAGE_CONTROLS_DELETE_SPOTS)
        removeEventTypeListener(EVENT_TYPE_FLYER_PAGE_CONTROLS_AUTO_NUMBER)
        removeEventTypeListener(EVENT_TYPE_FLYER_SAVE_FRAMES_DATA_AND_AUTO_NUMBER)
        removeEventTypeListener(EVENT_TYPE_FLYER_PAGE_CONTROLS_RENUMBER_FROM)

        // removeEventTypeListener(EVENT_DATA_TYPE_SPOT_DRAG_BOTTOM_RIGHT)

        this._keyboardManager?.dispose();

        //
        this.removeAllEventListeners();
    }

    public onMainSpotsContainerClick = (event: any) => {
        console.log(`click on frame`);
        if(event.nativeEvent.button !== 0){
            return;
        }
        if(this.isInScallingIndividualSpotsMode){
            return;
        }

        let functions = this._spotsFunctions!;

        let currentTarget = event.currentTarget;
        let target = event.target;

        let innerSpots = this.innerSpots

        if (currentTarget instanceof Spots) {
            let spots: Spots = currentTarget as Spots

            if (!spots.isPageContainer) {
                return;
            }

            if (target.parent instanceof Spot) {

                if(this._currentEditedSpot) {
                    this._currentEditedSpot.showEditMode(false);
                    this._currentEditedSpot = null;
                }

                if(this.isInMoveSpotsMode) {
                   return;
                }

                if (target instanceof StrokedText) {
                    // functions.selectAllPageSpots(false);
                    // let spot: Spot = target.parent as Spot
                    // spot.showEditMode(true);
                    // this._currentEditedSpot = spot;
                }
                else {
                    // click on Spot
                    console.log('Spot Click')

                    if (this.isInCtrlClickMode) {
                        this.isInCtrlClickMode = false;

                        let spot: Spot = target.parent as Spot
                        let lastSelected = spot.isSelected
                        let nextSelected = !lastSelected
                        spot.setSelected(nextSelected);

                        // for the case where we have other spot selected
                        functions.putSelectedSpotsChildrenOnTop();

                        if (nextSelected) {
                            this.addChild(spot)
                        }
                        else {
                            // will stay beloy all spots
                        }

                    }
                    else {

                        let spot: Spot = target.parent as Spot
                        const selectedSpots = functions.getSelectedSpots(true);
                        if(!spot.isSelected || selectedSpots.length > 1) {
                            functions.selectAllPageSpots(false);
                            spot.setSelected(true, this._isDisabledZoom);
                            this.addChild(spot);
                        }
                        else {
                            let spot: Spot = target.parent as Spot
                            if(spot.hasNumber) {
                                // functions.selectAllPageSpots(false);
                                this._spotsFunctions?.changeIconDataForSelectedFrames(spot._frameIconData!)
                                spot.showEditMode(true);
                                this._currentEditedSpot = spot;
                            }
                        }

                    }
                }
            }
            else if(target.parent instanceof Spots){

                // => click on stage

                functions.selectAllPageSpots(false);

                if(this._currentEditedSpot) {
                    this._currentEditedSpot.showEditMode(false);
                    this._currentEditedSpot = null;
                }
            }

            if (!functions.hasSelectedSpots()) {
                // if no frames selected
                dispatchEventType(EVENT_TYPE_SPOTS_NO_SPOTS_SELECTED)
            }
            else if (functions.hasAllSpotsSelected()) {
                // if all spots selected
                dispatchEventType(EVENT_TYPE_SPOTS_ALL_SPOTS_SELECTED_WITH_CTRL_A)
            }
            else {
                // if only few selected
                dispatchEventType(EVENT_TYPE_SPOTS_UNSELECT_ONE_OR_MORE_SPOTS)
            }

            //
            this.updateStage()
        }
    }

    public get innerSpots() {
        return this._innerSpots;
    }

    public set innerSpots(value: Array<Spot>) {
        this._innerSpots = value;
    }

    private onAddedToStage(event: any) {
        if (event.target.stage != null) {
            this._canvasMouseTracker = new CanvasMouseTracker(this.stage);
            this._canvasMouseTracker.addMouseIcon('framesGridCreationIcon', framesGridCreationIcon)
            this._canvasMouseTracker.addMouseIcon('noAccessIcon', noAccessIcon)
            this._canvasMouseTracker.addMouseIcon('moveFramesIcon', moveFramesIcon)
        }
    }

    private onRemovedFromStage() {

    }

    public get isPageContainer() {
        return this._isPageContainer;
    }




    public get backgroundScaleX() {
        return this._hitLayer!.scaleX;
    }

    public get backgroundScaleY() {
        return this._hitLayer!.scaleY;
    }

    public initSpotsDtos(flyerPageDto: FlyerPageDto, originalPageWidth: number, originalPageHeight: number, isHorizontalOrientationForFrames: boolean, isSelectedAllFramesModeOn: boolean, selectedFrames?: FlyerPageSpotDto[]) {
        this._flyerPageDto = flyerPageDto;
        this._spotsFunctions?.initSpotsDtos(flyerPageDto, originalPageWidth, originalPageHeight, isHorizontalOrientationForFrames, isSelectedAllFramesModeOn, selectedFrames);
        this.updateStage();
    }

    public updateStage() {
        if (this.stage) {
            this.stage.update();
        }
        let functions = this._spotsFunctions!;
        const selectedSpotsArray = functions.selectedSpots();
        const selectedSpotsDataArray = functions.selectedSpotsDataFromCanvas();
        dispatchEventDataType(EVENT_TYPE_GET_ALL_SELECTED_SPOTS, {
            selectedFrames: selectedSpotsArray,
            selectedFramesData: selectedSpotsDataArray
        });
    }

    public setNextGgridSize(rows: number, columns: number) {
        this._nextGgridSize = new Point()
        this._nextGgridSize.y = rows;
        this._nextGgridSize.x = columns;

        this._canvasMouseTracker!.showMouseIcon('framesGridCreationIcon');
    }

    public get nextGgridSize() {
        return this._nextGgridSize;
    }

    public get isRightCollider() {
        return this._isRightCollider;
    }
    public set isRightCollider(value: boolean) {
        this._isRightCollider = value;
    }
    public get isBottomCollider() {
        return this._isBottomCollider;
    }
    public set isBottomCollider(value: boolean) {
        this._isBottomCollider = value;
    }

    public get pageWidth(): number {
        return this._pageWidth
    }
    public get pageHeigth(): number {
        return this._pageHeigth
    }

    public get isInCtrlClickMode(): boolean {
        return this._isInCtrlClickMode
    }
    public set isInCtrlClickMode(value: boolean) {
        this._isInCtrlClickMode = value
    }

    public get spotsFunctions(): SpotsFunctions | null {
        return this._spotsFunctions
    }

    public get redStokedShape(): createjs.Shape | null {
        return this._redStokedShape
    }

    public set redStokedShape(value: createjs.Shape | null) {
        this._redStokedShape = value;
    }

    public get isMouseDown(): boolean {
        return this._isMouseDown
    }
    public set isMouseDown(value: boolean) {
        this._isMouseDown = value
    }

    public get mouseX0(): number {
        return this._mouseX0
    }
    public set mouseX0(value: number) {
        this._mouseX0 = value
    }
    public get mouseY0(): number {
        return this._mouseY0
    }
    public set mouseY0(value: number) {
        this._mouseY0 = value
    }
    public get currentMouseX(): number {
        return this._currentMouseX
    }
    public set currentMouseX(value: number) {
        this._currentMouseX = value
    }

    public get currentMouseY(): number {
        return this._currentMouseY
    }
    public set currentMouseY(value: number) {
        this._currentMouseY = value
    }
    public get lastMouseX(): number {
        return this._lastMouseX
    }
    public set lastMouseX(value: number) {
        this._lastMouseX = value
    }

    public get lastMouseY(): number {
        return this._lastMouseY
    }
    public set lastMouseY(value: number) {
        this._lastMouseY = value
    }
    public get currentSpotsContainer(): Spots | null {
        return this._currentSpotsContainer
    }
    public set currentSpotsContainer(value: Spots | null) {
        this._currentSpotsContainer = value
    }
    public get canvasMouseTracker(): CanvasMouseTracker | null {
        return this._canvasMouseTracker
    }

    public get isInScallingIndividualSpotsMode(): boolean {
        return this._isInScallingIndividualSpotsMode
    }
    public set isInScallingIndividualSpotsMode(value: boolean) {
        this._isInScallingIndividualSpotsMode = value
    }

    public get currentSelectedSpotsDtos(): SpotModelViewDto[] | null {
        return this._currentSelectedSpotsDtos
    }
    public set currentSelectedSpotsDtos(value: SpotModelViewDto[] | null) {
        this._currentSelectedSpotsDtos = value
    }
    public get currentSelectedSpotScallerDto(): SpotModelViewDto | null {
        return this._currentSelectedSpotScallerDto
    }
    public set currentSelectedSpotScallerDto(value: SpotModelViewDto | null) {
        this._currentSelectedSpotScallerDto = value
    }
    public get isInMoveSpotsMode(): boolean {
        return this._isInMoveSpotsMode
    }
    public set isInMoveSpotsMode(value: boolean) {
        this._isInMoveSpotsMode = value
    }
    public get spotsTranslationManager(): SpotsTranslationManager | null {
        return this._spotsTranslationManager
    }
    public get translationOffsetX(): number {
        return this._translationOffsetX
    }
    public set translationOffsetX(value: number) {
        this._translationOffsetX = value
    }
    public get translationOffsetY(): number {
        return this._translationOffsetY
    }
    public set translationOffsetY(value: number) {
        this._translationOffsetY = value
    }
    public set nextGgridSize(value: Point | null) {
        this._nextGgridSize = value
    }
    public get persistenceManager(): SpotsPersistenceManager | null {
        return this._persistenceManager
    }
    public get flyerPageDto(): FlyerPageDto | null {
        return this._flyerPageDto
    }
    public get isInCollisionState(): boolean {
        return this._isInCollisionState
    }
    public set isInCollisionState(value: boolean) {
        this._isInCollisionState = value
    }
}